import { mapRestaurantsResponse } from '@store/table/helpers/mapRestaurantResponse';
import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import {
  MappedRestaurantsSchema,
  MappedRestaurantsType,
} from '../schemas/MappedRestaurantResponse.schema';
import { TABLES_REQUEST_TIMEOUT } from './useGetTablesAvailability';

export function useGetRestaurants(propertyId: number, language: string) {
  return useQuery({
    queryKey: getRestaurantsKey({ propertyId, language }),
    queryFn: () => getRestaurants({ propertyId, language }),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

export async function getRestaurants({
  propertyId,
  language,
}: {
  propertyId: number;
  language: string;
}): Promise<MappedRestaurantsType | undefined> {
  const response = await request.v2.get(`${propertyId}/tables/restaurants/all/${language}`, {
    timeout: TABLES_REQUEST_TIMEOUT,
  });
  const result = MappedRestaurantsSchema.safeParse(mapRestaurantsResponse(response.data));
  if (result.success) {
    return result.data;
  }
}

export const getRestaurantsKey = ({
  propertyId,
  language,
}: {
  propertyId: number;
  language: string;
}) => ['restaurants', propertyId, language];
